import 'bootstrap/js/src/tooltip';
import 'bootstrap/js/src/popover';
import '../../static/major/js/libs/prettyCheckable.js';
import 'select2';

import 'jquery-toggles';
import {OnestepSigninBox} from '../account/social_login';

let reviews = reviews || {
    // Allow no more than N checkbox selections.
    limitChosen: function(fields) {
        var max = 3;

        $(fields).on('click', function() {
            var checked = $(fields + ':checked').length;
            if (checked > max) {
                return false;
            }
        });
    },
    showAnswers: function() {
        function setAnswer(radio) {
            // Clicking on label[for] ain't automagically working on IE < 9 nor Firefox.
            radio.attr('checked', 'checked');

            var label  = radio.data('description') || radio.data('label');
            var answer = radio
                            .closest('fieldset')
                                .siblings('[data-js="selected-answer"]'),
                btnGroup = radio.parent().parent();

            if (!answer.length) {
                btnGroup.siblings('[data-js="selected-answer"]');
            }

            if (!answer.length) {
                answer = $('[data-js="selected-answer"][data-field-name="' + radio.attr('name') + '"]');
            }

            if (btnGroup.data('user-related-toggle')) {
                label = btnGroup.data('user-related-toggle') + ' is ' + label.toLowerCase() + ' to me.';
            }
            answer.find('.selected-value').text(label);

            if (!answer.hasClass('ignore-formatting')) {
                var type = radio.data('type');
                answer
                    .removeClass('positive')
                    .removeClass('negative')
                    .removeClass('ignore-formatting')
                    .addClass(type);
            }

            if (radio.data('js') === 'field-switch') {
                    // switches off other fields in same button group, even with other name
                    radio
                        .closest('.main-options') // group of choices
                            .parent()
                                .find('[data-js="reset-choices"]').removeClass('active');

                    // clicks the original tag in form.
                    $('.pros-cons-tags .' + radio.data('category') + ' input[value="' + radio.val() + '"]:not(:checked)')
                        .siblings('a').trigger('click');
                }
            else
                $('[name="' + radio.attr('name') + '"]:not(checked)').each(function() {
                    $(this)
                        .parent() // label
                            .removeClass('active');
                });
        }
        // Display the "Your Answer" span.
        // IE < 8 does not support event delegation, ie 'change' and Firefox was requiring a double
        // click before showing this guy up, so we use this instead of "on('change')"
        //   * See: http://goo.gl/Qffov
        $('.choices label[type="button"]').on('click', function() {
            if (! $(this).hasClass('active') ) {
                setAnswer($(this).children('input[type=radio],input[type=checkbox]').eq(0));
            }
        });
        $('[data-js="reset-choices"]').on('click', function() {
            $(this).parent() // .extra-options
                .siblings('.main-options')
                    .find('.active').removeClass('active')
                        .find('input[type=radio]').removeAttr('checked');

            // reset selected original tags.
            $('.tagged-choices-tabs input[value="' + $(this).find('input').val() + '"]:checked')
                .siblings('a').trigger('click');
        });

    },
    setOptionalDate: function(value, field, focusDate) {
        if (value === field.otherVal) {
            field.year.removeAttr( 'disabled');
            field.month.removeAttr('disabled');

            if (focusDate) {
                field.month.focus();
            }

            // Setting the hidden day field to "15" forces a date field
            // validation by producing an invalid date.
            field.day.val('15');
            field.container.show();
        } else {
            field.container.hide();
            field.year[0].selectedIndex  = 0;
            field.month[0].selectedIndex = 0;
            field.month.children('option:first').attr('value', '0');
            field.day[0].selectedIndex   = 0;
            field.year.attr('disabled',  'disabled');
            field.month.attr('disabled', 'disabled');
        }
    },
   setOptionalDay: function(month, day) {
       month.on('change', function() {
           if (this.value === '0') {
               day[0].selectedIndex = 0;
           } else {
               day.val('15');
           }
       });
   },
   setOptionalMonth: function(year, month) {
       year.on('change', function() {
            // Since the month field is optional and our date field makes no sense
            // with a year option with no month, we slyly set the "No option" value
            // to July, mid-year.
            if (this.value === '0') {
                // None
                month.children('option:first').attr('value', '0');
            } else {
                // July
                month.children('option:first').attr('value', '7');
            }
        });
   },
   toggleProsCons: function() {
        $('[data-field="pros-cons"]').toggleClass('hidden', typeof $('[name=rating]:checked').val() === 'undefined');
   },
   setStarRatings: function() {
        var $this = this;

        // "Your Answer" styles for the "Overall Rating" field
        var ratingFloor = 3;

        // Set styles on load
        var rating = $('[name=rating]:checked');
        if (rating.length) {
            var value = parseInt(rating.val(), 10);

            rating.siblings('.star-rating-control').children('.star-rating').each(function() {
                var anchor = $(this).find('a');
                var ratingValue = parseInt(anchor.text(), 10);

                if (value === ratingValue) {
                    rating
                        .parent().siblings('[data-js="selected-answer"]')
                                     .addClass(value >= ratingFloor ? 'positive' : 'negative')
                                         .find('.rating-choice')
                                             .text(anchor.attr('title'));

                    return false;
                }
            });
        }

        $('.star-rating').on('click', function() {
            var rating = {
                value:    $(this).children('[title]').text(),
                title: $(this).children('[title]').attr('title')
            };

            var answer = $(this)
                             .parent() // .star-rating-control
                                 .parent() // div
                                     .siblings('[data-js="selected-answer"]');

            if (parseInt(rating.value, 10) >= ratingFloor)  {
                answer.removeClass('negative').addClass('positive')
                   .find('.rating-choice').text(rating.title);
            } else {
                answer.removeClass('positive').addClass('negative')
                    .find('.rating-choice').text(rating.title);
            }


            $this.toggleProsCons();
        });

        $('.rating-cancel a').on('click', function() {
            var answer = $(this)
                             .parent() // .rating-cancel
                                 .parent() // .star-rating-control
                                     .parent() // div
                                         .siblings('[data-js="selected-answer"]');

            answer.removeClass('positive').removeClass('negative')
                  .find('.rating-choice').text('Select a star rating.');

            $('[data-field="pros-cons"]').addClass('hidden');
        });
   },

   setToggleSwitches: function() {
        // Apply the jquery-toggles plugin
        $('[data-js="toggle"]').each(function() {
            var checkbox = $($(this).data('checkbox'));
            $(this).toggles({
                drag: false,
                text: {
                    on:  'Yes',
                    off: 'No'
                },
                checkbox: checkbox,
                on: checkbox.is(':checked')
            });
        });
       $('[data-js="switcher-group"] [data-js-switcher]').on('click', function(e) {
            e.preventDefault();
            var isOn = $(this).data('js-switcher') === 'on';
            $('#' + $(this).parent().data('js-input')).prop('checked', isOn);
            $(this)
                .parent()
                    .find('[data-js-switcher="' + (isOn ? 'off' : 'on') + '"]').removeClass('active')
                    .end()
                .end()
                .addClass('active');
       });
   },
   setPrettyCheckables: function() {
       // TODO: Optimize repetitive calls to checkTagSelection and such.

        function hideAnswerTabs() {
            $('.tagged-category [data-js="selected-answer"]').each(function() {
                if (!$(this).find('[data-value]').length) {
                    $(this).hide();
                }
            });
        }

        function setSelectedValues(tags_field) {
            var otherCollections = $('[data-js="tag-collection"]').not(tags_field);
            category = $('.tagged-category[data-field-id="' + tags_field.attr('id') + '"]');
            tags_field.find('option').each(function() {
                var val = $(this).val();
                var answer = category.find('[data-js="selected-answer"] [data-value="' + val + '"]');

                if (answer.length) {
                    $(this).attr('selected', 'selected');
                    otherCollections.find('option[value="' + val + '"]').removeAttr('selected');

                } else {
                    $(this).removeAttr('selected');
                }
            });
        }

        function setAnswerTooltips() {
            $('html.no-touch .pros-cons-tags [data-js="selected-answer"] .prettycheckbox')
                .attr('rel', 'tooltip')
                .attr('data-original-title', 'Remove item')
                .tooltip();
        }

        function addAnswer(field, category) {
            category = category || field.closest('.tagged-category');
            var val = field.val();

            // Avoid duplicates.
            if (category.find('[data-js="selected-answer"] [data-value="' + val + '"]').length) {
                return false;
            }

            var label = field.data('label');
            var description = field.data('description');

            var input = $('<dt>', {
                                'data-value': val,
                                'html': $('<input>', {
                                    'type': 'checkbox',
                                    'checked': 'checked',
                                    'value': val,
                                    'class': 'custom-checkbox',
                                    'style': 'display: none;',
                                    'data-label': label,
                                    'data-description': description
                                })
                            });

            var desc = $('<dd>', {
                'data-value': val,
                'html': ($('[data-js="content-area"]').length ? '<b>' + label + ':</b> ' : '') + description
            });

            category
                .find('[data-js="selected-answer"]')
                    .show()
                    .find('.selected-tags')
                        .append(input)
                        .append(desc)
                    .end()
                    .find('[data-value="' + val + '"] input')
                        .prettyCheckable()
                        .closest('.prettycheckbox')
                            .addClass('selected')
                        .end()
                    .end()
                .end();

            setAnswerTooltips();
        }

        function removeAnswer(field, category) {
            field
                .removeAttr('checked')
                .siblings('a')
                    .removeClass('checked')
                .end()
                .closest('.prettycheckbox')
                    .removeClass('selected')
                .end();

            var answers = category.find('[data-js="selected-answer"]');
            answers.find('[data-value="' + field.val() + '"]').remove();

            hideAnswerTabs();
        }

        function setInitialValues() {
            $('input.custom-checkbox').prettyCheckable();
            $('input.custom-checkbox[checked]').each(function() {
                $(this)
                    .siblings('a')
                        .attr('class', 'checked')
                    .end()
                    .closest('.prettycheckbox')
                        .addClass('selected')
                    .end();

                addAnswer($(this), null);
            });
        }

        setInitialValues();

        function canAddTag(category) {
            var selected = category
                               .find('#id_' + category.data('type') +
                                '_tags option[selected="selected"]')
                               .length;

            var limit = category.data('maxTags');
            var error = category.find('.alert-error');

            return selected < limit;
        }

        function showTagErrors(category) {
            var limit = category.data('maxTags');
            var error = category.find('.alert-error');

            if (error.length) {
                if (error.is(':visible') && !error.is(':animated')) {
                    error.effect("highlight", {}, 1000);
                } else {
                    error.show();
                }
            } else {
                error = $('<div>', {
                    'class': 'alert alert-error',
                    'html': 'Select up to ' + limit + ' choices.'
                });

                var search = category.find('[data-js="selected-answer"]');
                error.insertBefore(search);
            }
        }

        function checkTagSelection(category, hideErrors) {
            if (canAddTag(category)) {
                category
                    .find('.alert-error')
                        .hide()
                    .end()
                    .find('.tagged-choices-tabs .prettycheckbox')
                        .removeClass('disabled')
                    .end();

                return true;
            } else {
                if (!hideErrors) {
                    showTagErrors(category);
                }
                category
                    .find('.tagged-choices-tabs .prettycheckbox:not(.selected)')
                        .addClass('disabled')
                    .end();

                return false;
            }
        }

        $('.tagged-category').each(function() {
            checkTagSelection($(this));
        });

        $('.tagged-choices-tabs .prettycheckbox a,' +
          '.tagged-choices-tabs .prettycheckbox label').on('click', function(e) {
              if ($(this).closest('.prettycheckbox').hasClass('disabled')) {
                  showTagErrors($(this).closest('.tagged-category'));
              }
          });

        $('.tagged-choices-tabs input.custom-checkbox')
            //.prettyCheckable()
            .on('change', function() {
                var field = $(this);
                var checked = field.is(':checked');
                var currentTab = field.closest('.tab-pane').prop('id');
                var val = field.prop('value');
                var label = field.data('label');
                var fieldGroup = field.closest('.pros-cons-tags');
                var description = field.data('description');
                var type = field.closest('.tagged-category').data('type');

                $(this)
                    .closest('.prettycheckbox')
                        .toggleClass('selected', checked)
                        .removeClass('disabled-tag');

                // update concern tags
                if (checked)
                    $('[data-js="field-switch"][data-category="' + type  + '"]' +
                        '[value="' + val + '"]:not(:checked)').trigger('click');
                else
                    $('[data-js="field-switch"][value="' + val + '"]')
                        .closest('[data-js="field-switch-group"]')
                            .find('[data-js="reset-choices"]').trigger('click');

                if ($('[data-js="content-area"]').length) {
                    fieldGroup
                        .find('.tagged-category:not([data-type="' + type + '"])')
                            .find('[value="' + val + '"]')
                                .removeAttr('checked')
                                .siblings('a')
                                    .removeClass('checked')
                                .end()
                                .closest('.prettycheckbox')
                                    .removeClass('selected')
                                    .toggleClass('disabled-tag', checked)
                                .end()
                            .end()
                            .find('[data-js="selected-answer"]')
                                .find('dt[data-value="' + val + '"]')
                                    .remove()
                                .end()
                                .find('dd[data-value="' + val + '"]')
                                    .remove()
                                .end()
                            .end();

                    fieldGroup.find('[data-js="selected-answer"]').each(function() {
                        if (!$(this).find('dt').length) {
                            $(this).hide();
                        }
                    });
                }

                var category = field.closest('.tagged-category');
                if (checked && !checkTagSelection(category)) {
                    return false;
                }

                var answer = category
                                .find('[data-js="selected-answer"] [data-value="' + val + '"]');
                if (checked && !answer.length) {
                    addAnswer(field, category);
                } else {
                    answer.each(function() {
                        $(this).remove();
                    });
                    hideAnswerTabs();
                }

                field
                    .closest('.prettycheckbox[rel=tooltip]')
                        .tooltip('hide')
                    .end();

                var categoryType = category.data('type');
                setSelectedValues($('#id_' + categoryType + '_tags'));
                checkTagSelection(category, true);
            });

        $(document).on('change', '.tagged-category [data-js="selected-answer"] input.custom-checkbox', function() {
                var field = $(this);
                var checked = field.is(':checked');
                var val = field.prop('value');

                var category = field.closest('.tagged-category');

                if (!checked) {
                    field
                        .closest('.tagged-category')
                            .find('input[value="' + val + '"]')
                                .removeAttr('checked')
                                .siblings('a')
                                    .removeClass('checked')
                                .end()
                                .closest('.prettycheckbox')
                                    .removeClass('selected')
                                .end()
                            .end()
                        .end()
                        .closest('[data-js="selected-answer"]')
                            .find('[rel=tooltip]')
                                .tooltip('hide')
                            .end()
                            .find('[data-value="' + val + '"]')
                                .remove()
                            .end()
                        .end();

                    hideAnswerTabs();
                    var categoryType = category.data('type');
                    setSelectedValues($('#id_' + categoryType + '_tags'));
                    checkTagSelection(category, true);
                }
            });

        $('html.no-touch .pros-cons-tags input.custom-checkbox[data-description]').each(function() {
            var description = $(this).data('description');
            var placement = $(this).data('placement') || 'top';
            if (description) {
                $(this)
                    .closest('.prettycheckbox')
                        .attr('rel', 'tooltip')
                        .attr('data-original-title', description)
                        .attr('data-placement', placement)
                        .tooltip();
            }
        });

        var search_placeholders = {};
        $('.tagged-category').each(function() {
            search_placeholders[$(this).data('type')] = $(this)
                                                            .find('input.pros-cons-search')
                                                                .attr('placeholder');
        });

        function getProsCons(type) {
            // type: 'praise' or 'complaint'.

            var results = [];
            $(".tagged-category[data-type='" + type + "'] [data-type='tags'] input").each(function() {
                var placeholder = search_placeholders[type];
                results.push({
                    id:          $(this).val(),
                    title:       $(this).data('label')       || '',
                    description: $(this).data('description') || '',
                    checked:     $(this).prop('checked'),
                    type:        type,
                    placeholder: '<span class="select2-default">' + placeholder + '</span>'
                });
            });

            return results;
        }

        $(".pros-cons-search").select2({
            minimumInputLength: 1,
            query: function (query) {
                var options = getProsCons(query.element.data('type'));

                var data = {results: []};
                for(var i in options) {
                    var option = options[i];
                    term = query.term.trim();
                    if (term && (query.matcher(term, option.title) ||
                        query.matcher(term, option.description))) {
                        option.term = term;
                        data.results.push(option);
                    }
                }

                query.callback(data);
            },
            formatResult: function (tag) {
                var title = [];
                Select2.util.markMatch(tag.title, tag.term, title,
                                       $.fn.select2.defaults.escapeMarkup);

                var description = [];
                Select2.util.markMatch(tag.description, tag.term, description,
                                       $.fn.select2.defaults.escapeMarkup);

                var markup  = "<div class='pros-cons-tags clearfix'>";
                markup        += "<div class='result-tag " + tag.type + "'>";
                markup          += "<div class='clearfix prettycheckbox " +
                                    (tag.checked ? 'selected' : '') + "' ";
                markup               += "data-original-title='Remove item' rel='tooltip'>";
                markup            += "<a href='#' class='" + (tag.checked ? 'checked' : '') + "'></a>";
                markup            += "<label>" + title.join('') + "</label>";
                markup          += "</div>";
                markup        += "</div>";
                markup        += "<div class='result-tag-desc'>" + description.join('') + "</div>";
                markup     += "</div>";

                return markup;
            },
            formatSelection: function (tag) {
                // On selection, just revert to the placeholder in a hackish way, as
                // $(this).select2('val', null) is being more of a pain than what its worth...
                return tag.placeholder; // tag.title
            },
            dropdownCssClass: "bigdrop", // Apply CSS that makes the dropdown taller.
            escapeMarkup: function (m) { return m; } // We are displaying html in results.
        }).on('change', function(e) {
            var category = $(e.currentTarget).closest('.tagged-category');
            var field = category.find('.tagged-choices-tabs input[value="' + e.val + '"]:first');
            var checked = field.is(':checked');

            if (category.find('[data-js="selected-answer"] [data-value="' + e.val + '"]').length) {
                removeAnswer(field, category);
            } else {
                if (!checked && canAddTag(category)) {
                    field
                        .attr('checked', 'checked')
                        .siblings('a:first')
                            .addClass('checked')
                        .end()
                        .closest('.prettycheckbox')
                            .addClass('selected')
                        .end();

                    addAnswer(field, category);
                }
            }
            setSelectedValues($('#id_' + category.data('type') + '_tags'));
            checkTagSelection(category);
        });

        setAnswerTooltips();
   },
   focusError: function() {
       var first_error = $('.errorlist:first');
       if (first_error.closest('tr').length) {
           first_error = first_error.closest('tr');
       } else {
           first_error = first_error.closest('.row');
       }

        if (first_error.length) {
            var new_position = first_error.offset();
            window.scrollTo(new_position.left, new_position.top);
        }
   },
   setFriendReviewsScrolling: function() {
       var progBar = $('[data-js="progress-bar"]');

       //Firefox places the overflow at the `html` level, while Gecko prefers the `body`.
       var scrollElement = $('html, body');
       var header = $('.navbar');
       $('[data-js="content-area"]').find('[data-js="btn-prev"], [data-js="btn-next"]').on('click', function(e) {
           // Consider the sticky header's height before scrolling.
           var topElement = progBar;
           if (!progBar.length) {
                topElement = $('[data-js="content-area"]');
           }

           // Land right on top of the progress bar.
           var offset = 5;

           // Header position:
           //   - fixed: the header is being shown
           //   - absolute: the header is hidden
           if (header.css('position') === 'absolute') {
                offset += header.height();
           }

           var top_position = topElement.offset().top - offset;
           if ($.fn.animate) {
                scrollElement.animate({'scrollTop': top_position}, 500, 'swing');
            } else {
                $(window).scrollTop(top_position);
            }
       });
   },
   displayCharsLeft: function() {
        $('.chars-left').each(function() {
            var element = $(this);
            var input = $(element.data('input'));
            if (input.length) {
                input.on('input', function() {
                    var maxLength = input.attr('maxlength');
                    var remaining = maxLength - input.val().length;
                    element.find('.counter').text(remaining);
                    element.find('.plural').text(remaining != 1 ? 's' : '');
                });
            }
        });
   }
};

$(function() {
    $('html.no-touch [rel=tooltip]').tooltip();
    $('[rel=popover]').popover({ trigger: "hover", html: true });

    reviews.limitChosen('[id^="id_pros_"]');
    reviews.limitChosen('[id^="id_cons_"]');
    reviews.showAnswers();
    reviews.focusError();
    reviews.setStarRatings();
    reviews.setFriendReviewsScrolling();
    reviews.displayCharsLeft();
    reviews.setToggleSwitches();

    if ($.fn.prettyCheckable) {
        reviews.setPrettyCheckables();
    } else {
        console.warn('prettyCheckable not found.');
    }

    new OnestepSigninBox($('[data-js=dialog-signin-box]'), {
        oneStepDone: null,
        autoRegister: true
    });
});
